import React from "react";

export default function AuthorCopyRight({ name }) {
    
    return (
      <div >
        <h2 className="author">{name}</h2>
      </div>
    );
  };